import React, { useState, useEffect, useRef } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useHistory } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";
import { genUserForCopyList } from "../../../service/GEN/GenService";
import ValidateService from "../../../components/ValidateService/ValidateService";
import { dataUserSession } from "../../../utilities/dataSession";
import { MultiSelect } from 'primereact/multiselect';
import { P401GetData } from "../../../service/400/P401Service";
import { validateInputText } from "../../../utilities/ValidateUtil";
import { itemTemplate,  selectedItemsLabel } from "../../../utilities/MultiSelectUtil";

export default function P401Dialog({ dialog, setDialog,submitForm,submitted }) {

    const toast = useRef(null);
    const history = useHistory();
    const [errData, setErrData] = useState(null);

    const [searchData] = useState({
        userId: dataUserSession() ? dataUserSession().userId : "",
    });
    const [userList, setUserList] = useState([]);
    const [originalUserId, setOriginalUserId] = useState("");

    const [multiselectValue, setMultiselectValue] = useState([]);
    const [contractList, setContractList] = useState([]);

    useEffect(() => {
        if (!dataUserSession()) {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        onGenUserForCopyList();
    }, [searchData]);

    useEffect(() => {
        // console.log('multiselectValue ',multiselectValue);
        onSetMultiselectValue();
    }, [contractList]);

    useEffect(() => {
        onP401GetData();
        setMultiselectValue([]);
    }, [originalUserId]);

    const onGenUserForCopyList = () => {
        genUserForCopyList(searchData).then(
            (res) => {
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setUserList(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setErrData(err);
            }
        );
    };

    const onP401GetData = () => {
        let req = {
            userId: searchData.userId,
            editUserId: originalUserId,
        };
        P401GetData(req).then(
            (res) => {
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    let tmpList = [];
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });

                        tmpList.push({
                            name: element.contractNo,
                            code: element.contractNo,
                            selectedFlag : 'Y'//element.selectedFlag
                        });
                        index++;
                    });

                    setContractList(tmpList);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setErrData(err);
            }
        );
    };

    const onSetMultiselectValue = () =>{
        const data = []
        contractList.forEach((item)=>{
            if(item.selectedFlag === "Y"){
                data.push(
                    // code: item.code,
                    item.name
                )
            }
            
        })

        setMultiselectValue(data)
    }

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    //data
    const renderFooter = () => {
        return (
            <div style={{ textAlign: "right" }}>
                <Button label="บันทึก" icon="pi pi-save" onClick={() => submitForm(multiselectValue)} autoFocus className="p-button p-button-success" />
                <Button label="ยกเลิก" icon="pi pi-times" onClick={() => setDialog(false)} className="p-button-danger p-button" />
            </div>
        );
    };

    const labelTemplate = (data) => {
        return <>{data.userId + " : " + data.userName}</>;
    };


    return (
        <>
            <ValidateService err={errData} setErr={setErrData} />
            <Dialog 
                header="คัดลอกเลขที่สัญญาจากผู้ใช้อื่นฯ" 
                visible={dialog.dialog} 
                style={{ width: "50vw" }} 
                className="p-fluid" 
                footer={renderFooter()} 
                onHide={() => setDialog(false)} 
                blockScroll={true} 
                className="p-fluid" 
                maximizable={true}
                
            >
                <div className="p-grid" style={{ marginBottom: 30 }}>
                    <div className="p-field p-col-12 p-md-12">
                        <label htmlFor="caseNo">คัดลอกจากรหัสผู้ใช้งาน</label>
                        <div className="p-inputgroup">
                            <Dropdown id="originalUserId" value={originalUserId} onChange={(e) => setOriginalUserId(e.target.value)} options={userList} optionValue="userId" optionLabel={labelTemplate} placeholder="เลือก ผู้ใช้งาน" />
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-12">
                        <label>เลขที่สัญญา</label>
                        <MultiSelect 
                            value={multiselectValue} 
                            options={contractList} 
                            onChange={(e) => setMultiselectValue(e.value)} 
                            optionLabel="name" 
                            optionValue="code"
                            placeholder="เลือก เลขที่สัญญา" 
                            filter 
                            listStyle={{ maxHeight: "250px" }}
                            className="p-invalid"
                            disabled = {!contractList || contractList.length <= 0}
                            selectedItemsLabel ={selectedItemsLabel}
                            itemTemplate={itemTemplate} 
                        />
                        {submitted && multiselectValue.length<=0 && validateInputText("multiselectValue", "เลขที่สัญญา")}
                    </div>
                    <div className="p-field p-col-12 p-md-12" style={{marginTop:150}}>
                    </div>
                    <br />
                </div>
            </Dialog>
        </>
    );
}
